import { device } from 'src/theme/theme'
import styled from 'styled-components'

export const TeacherContainer = styled.div`
  padding: 0 1rem 3.75rem;
  max-width: 1117px;
  margin: 0 auto;

  @media ${device.laptopL} {
    padding: 0 0 3.75rem;
  }

  .player-wrapper {
    position: relative;
    padding-top: 56.25%; /* Player ratio: 100 / (1280 / 720) */
    margin-bottom: ${p => p.theme.spacing.medium};
  }

  .react-player {
    position: absolute;
    top: 5%;
    left: 5%;

    @media ${device.laptop} {
      top: 10%;
      left: 10%;
      width: 80% !important;
      height: 80% !important;
    }
  }

  .title {
    ${({ theme }) => theme.size.xl};
    ${({ theme }) => ({ ...theme.typography.primary.medium })};
    color: ${({ theme }) => theme.colors.primaryTextColor};
    margin-bottom: 16px;
  }
`

export const CategoryArea = styled.div`
  padding: 3.75rem 0 0;
  h3 {
    margin: 0 auto;

    @media ${device.laptop} {
      max-width: 100%;
      margin: 0;
    }
  }
`

export const Bio = styled.div`
  margin: 0 auto;

  p {
    margin-bottom: 30px;
    line-height: 25px;
  }

  @media ${device.tablet} {
    max-width: 100%;
  }

  h3 {
    ${({ theme }) => theme.size.xl};
    color: ${({ theme }) => theme.colors.primaryTextColor};
    margin-bottom: 16px;
  }
`

interface ImageProps {
  image: string
}

export const BoxImage = styled.div<ImageProps>`
  margin: 0 auto 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100px;
  height: 100px;
  border-radius: 50%;

  div {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-image: url(${({ image }) => image});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    border: 4px solid ${({ theme }) => theme.colors.palette.neutral400};
  }
`
